import { render, staticRenderFns } from "./kindergruppen.vue?vue&type=template&id=9f850948&scoped=true&"
import script from "./kindergruppen.vue?vue&type=script&lang=js&"
export * from "./kindergruppen.vue?vue&type=script&lang=js&"
import style0 from "./kindergruppen.vue?vue&type=style&index=0&id=9f850948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f850948",
  null
  
)

export default component.exports